// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableIndicesQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
}>;

export type SchemaTableIndicesQuery = {
  __typename?: "GraphqlQuery";
  getSchemaTableIndices: Array<{
    __typename?: "SchemaIndex";
    id: string;
    name: string;
    indexDefShort: string;
    constraintDef?: string | null;
    valid?: boolean | null;
    sizeBytes?: number | null;
    createdAt: number;
    lastUsedAt?: string | null;
    writeOverhead?: number | null;
  }>;
};

export const SchemaTableIndicesDocument = gql`
  query SchemaTableIndices($databaseId: ID!, $tableId: ID!) {
    getSchemaTableIndices(databaseId: $databaseId, schemaTableId: $tableId) {
      id
      name
      indexDefShort
      constraintDef
      valid
      sizeBytes
      createdAt
      lastUsedAt
      writeOverhead
    }
  }
`;

/**
 * __useSchemaTableIndicesQuery__
 *
 * To run a query within a React component, call `useSchemaTableIndicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableIndicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableIndicesQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *   },
 * });
 */
export function useSchemaTableIndicesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  > &
    (
      | { variables: SchemaTableIndicesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  >(SchemaTableIndicesDocument, options);
}
export function useSchemaTableIndicesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  >(SchemaTableIndicesDocument, options);
}
// @ts-ignore
export function useSchemaTableIndicesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableIndicesQuery,
  SchemaTableIndicesQueryVariables
>;
export function useSchemaTableIndicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableIndicesQuery,
        SchemaTableIndicesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableIndicesQuery | undefined,
  SchemaTableIndicesQueryVariables
>;
export function useSchemaTableIndicesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableIndicesQuery,
        SchemaTableIndicesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableIndicesQuery,
    SchemaTableIndicesQueryVariables
  >(SchemaTableIndicesDocument, options);
}
export type SchemaTableIndicesQueryHookResult = ReturnType<
  typeof useSchemaTableIndicesQuery
>;
export type SchemaTableIndicesLazyQueryHookResult = ReturnType<
  typeof useSchemaTableIndicesLazyQuery
>;
export type SchemaTableIndicesSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableIndicesSuspenseQuery
>;
export type SchemaTableIndicesQueryResult = Apollo.QueryResult<
  SchemaTableIndicesQuery,
  SchemaTableIndicesQueryVariables
>;
